import React from 'react';

export default function WelcomeForm({ onSubmit, onPreview, onHome, onGlossary }) {
  return (
    <div style={{ maxWidth: '600px', margin: '12rem auto 3rem auto', padding: '7rem' }}>
      
      {/* Top-left buttons */}
      <div style={{ position: 'absolute', top: '1rem', left: '1rem' }}>
        <button 
          onClick={onPreview}
          style={{ 
            padding: '0.6rem 1rem',
            backgroundColor: '#eee',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer',
            width: '200px',
            display: 'block',
            marginBottom: '0.5rem'
          }}
        >
          👀 Preview Report Only
        </button>

        <button 
          onClick={onHome}
          style={{ 
            padding: '0.6rem 1rem',
            backgroundColor: '#eee',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer',
            width: '200px',
            display: 'block',
            marginBottom: '0.5rem'
          }}
        >
          🏠 Home
        </button>

        <button
          onClick={onGlossary}
          style={{
            display: 'block',
            marginBottom: '0.5rem',
            padding: '0.6rem 1rem',
            width: '200px',
            backgroundColor: '#eee',
            border: '1px solid #ccc',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          📘 Glossary
        </button>

      </div>

      {/* Title and instructions */}
      <p style={{ marginBottom: '2rem', textAlign: 'center', fontSize: '1.1rem', lineHeight: '1.4' }}>
        This brief assessment measures your attention, memory, executive function, and mood.
        It takes about 10 minutes. Your responses are confidential and used to generate a tailored cognitive profile.
      </p>

      <div style={{ textAlign: 'center' }}>
        <button
          onClick={onSubmit}
          style={{
            backgroundColor: '#149854',
            color: '#fff',
            border: 'none',
            padding: '0.75rem 2rem',
            fontSize: '1.1rem',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          Start Assessment
        </button>
      </div>
    </div>
  );
}
